// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-splash .intro {
    font-size: 24px;
    line-height: 1.7em;
}
.welcome-splash .intro .beta {
    font-size: 16px;
    font-style: italic;
    line-height: 1.4em;
}

@media (width >= 700px) {
    .welcome-splash {
        display: grid;
        grid-template-columns: 1fr 1fr;
        margin: 200px auto;
        max-width: 1400px;
        width: 100%;
    }
    .welcome-splash .intro {
        padding: 15px 15px 15px 45px;
    }
}
@media (width < 700px) {
    .welcome-splash {
        width: 100%;
    }
    .welcome-splash .intro {
        padding: 5px 5px 5px 15px;
    }
    
}

`, "",{"version":3,"sources":["webpack://./client/pages/authentication/WelcomeSplash.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;QAClB,iBAAiB;QACjB,WAAW;IACf;IACA;QACI,4BAA4B;IAChC;AACJ;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,yBAAyB;IAC7B;;AAEJ","sourcesContent":[".welcome-splash .intro {\n    font-size: 24px;\n    line-height: 1.7em;\n}\n.welcome-splash .intro .beta {\n    font-size: 16px;\n    font-style: italic;\n    line-height: 1.4em;\n}\n\n@media (width >= 700px) {\n    .welcome-splash {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        margin: 200px auto;\n        max-width: 1400px;\n        width: 100%;\n    }\n    .welcome-splash .intro {\n        padding: 15px 15px 15px 45px;\n    }\n}\n@media (width < 700px) {\n    .welcome-splash {\n        width: 100%;\n    }\n    .welcome-splash .intro {\n        padding: 5px 5px 5px 15px;\n    }\n    \n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
